import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Share = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="vuesax/outline/share">
        <g id="share">
          <path
            id="Vector"
            d="M13.749 8.7134C13.4957 8.7134 13.2824 8.52007 13.249 8.26673C13.089 6.76007 12.2757 5.3934 11.0224 4.52673C10.7957 4.36673 10.7424 4.06007 10.8957 3.8334C11.0557 3.60673 11.369 3.5534 11.589 3.70673C13.0824 4.74007 14.0424 6.36673 14.2357 8.16007C14.2624 8.4334 14.069 8.68007 13.789 8.7134C13.7824 8.7134 13.7624 8.7134 13.749 8.7134Z"
          />
          <path
            id="Vector_2"
            d="M2.3266 8.74668C2.3066 8.74668 2.29327 8.74668 2.27327 8.74668C1.99994 8.71334 1.79994 8.46668 1.8266 8.19334C2.0066 6.40001 2.95994 4.78001 4.43327 3.73334C4.65994 3.57334 4.97327 3.62668 5.13327 3.85334C5.29327 4.08001 5.23994 4.39334 5.01327 4.55334C3.77327 5.42668 2.97327 6.79334 2.81994 8.30001C2.79994 8.55334 2.57994 8.74668 2.3266 8.74668Z"
          />
          <path
            id="Vector_3"
            d="M8.03868 15.0734C7.05201 15.0734 6.11201 14.8467 5.23201 14.4067C4.98534 14.28 4.88534 13.98 5.01201 13.7334C5.13867 13.4867 5.43867 13.3867 5.68534 13.5134C7.12534 14.24 8.85868 14.2534 10.312 13.5534C10.5587 13.4334 10.8587 13.54 10.9787 13.7867C11.0987 14.0334 10.992 14.3334 10.7453 14.4534C9.89201 14.8667 8.98534 15.0734 8.03868 15.0734Z"
          />
          <path
            id="Vector_4"
            d="M8.04083 5.62671C6.74083 5.62671 5.6875 4.57338 5.6875 3.27338C5.6875 1.97338 6.74083 0.920044 8.04083 0.920044C9.34083 0.920044 10.3942 1.97338 10.3942 3.27338C10.3942 4.57338 9.33417 5.62671 8.04083 5.62671ZM8.04083 1.92671C7.29417 1.92671 6.6875 2.53338 6.6875 3.28004C6.6875 4.02671 7.29417 4.63338 8.04083 4.63338C8.7875 4.63338 9.39417 4.02671 9.39417 3.28004C9.39417 2.53338 8.78083 1.92671 8.04083 1.92671Z"
          />
          <path
            id="Vector_5"
            d="M3.22052 13.78C1.92052 13.78 0.867188 12.7267 0.867188 11.4267C0.867188 10.1334 1.92052 9.07336 3.22052 9.07336C4.52052 9.07336 5.57385 10.1267 5.57385 11.4267C5.57385 12.72 4.52052 13.78 3.22052 13.78ZM3.22052 10.0734C2.47385 10.0734 1.86719 10.68 1.86719 11.4267C1.86719 12.1734 2.47385 12.78 3.22052 12.78C3.96719 12.78 4.57385 12.1734 4.57385 11.4267C4.57385 10.68 3.96719 10.0734 3.22052 10.0734Z"
          />
          <path
            id="Vector_6"
            d="M12.7791 13.78C11.4791 13.78 10.4258 12.7267 10.4258 11.4267C10.4258 10.1334 11.4791 9.07336 12.7791 9.07336C14.0791 9.07336 15.1324 10.1267 15.1324 11.4267C15.1258 12.72 14.0724 13.78 12.7791 13.78ZM12.7791 10.0734C12.0324 10.0734 11.4258 10.68 11.4258 11.4267C11.4258 12.1734 12.0324 12.78 12.7791 12.78C13.5258 12.78 14.1324 12.1734 14.1324 11.4267C14.1258 10.68 13.5258 10.0734 12.7791 10.0734Z"
          />
        </g>
      </g>
    </svg>
  );
};

Share.displayName = 'Share';
